var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.563,
    height: 21.599,
    viewBox: "0 0 21.563 21.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "followUp",
    transform: "translate(-413.935 -686.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14360",
    "data-name": "Path 14360",
    d: "M429.9,694.741H419.383v-1.315a.563.563,0,0,1,.563-.563h.939v.375a.751.751,0,0,0,1.5,0v-.375h1.5v.375a.751.751,0,0,0,1.5,0v-.375h1.5v.375a.752.752,0,0,0,1.5,0v-.375h.939a.564.564,0,0,1,.564.563Zm-8.64-2.63a.376.376,0,0,1,.751,0v1.127a.376.376,0,1,1-.751,0Zm3.005,0a.376.376,0,0,1,.751,0v1.127a.376.376,0,1,1-.751,0Zm3.005,0a.376.376,0,0,1,.751,0v1.127a.376.376,0,1,1-.751,0Zm2.066.376H428.4v-.376a.752.752,0,0,0-1.5,0v.376h-1.5v-.376a.751.751,0,0,0-1.5,0v.376h-1.5v-.376a.751.751,0,0,0-1.5,0v.376h-.939a.938.938,0,0,0-.939.939v7.513a.938.938,0,0,0,.939.939H425.2a.188.188,0,1,0,0-.376h-5.259a.564.564,0,0,1-.563-.563v-5.823H429.9v3.193a.188.188,0,1,0,.375,0v-4.883A.938.938,0,0,0,429.337,692.487Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14361",
    "data-name": "Path 14361",
    d: "M423.139,696.995v-.564h.752v.564Zm1.127-.564a.376.376,0,0,0-.375-.376h-.752a.376.376,0,0,0-.375.376v.564a.375.375,0,0,0,.375.375h.752a.375.375,0,0,0,.375-.375Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14362",
    "data-name": "Path 14362",
    d: "M420.885,696.995v-.564h.751v.564Zm1.127-.564a.376.376,0,0,0-.376-.376h-.751a.376.376,0,0,0-.375.376v.564a.375.375,0,0,0,.375.375h.751a.375.375,0,0,0,.376-.375Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14363",
    "data-name": "Path 14363",
    d: "M427.647,696.431h.751v.564h-.751Zm.751.939a.375.375,0,0,0,.376-.375v-.564a.376.376,0,0,0-.376-.376h-.751a.377.377,0,0,0-.376.376v.564a.376.376,0,0,0,.376.375Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14364",
    "data-name": "Path 14364",
    d: "M423.139,698.685v-.564h.752v.564Zm1.127-.564a.375.375,0,0,0-.375-.375h-.752a.375.375,0,0,0-.375.375v.564a.376.376,0,0,0,.375.376h.752a.376.376,0,0,0,.375-.376Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14365",
    "data-name": "Path 14365",
    d: "M420.885,698.685v-.564h.751v.564Zm1.127-.564a.375.375,0,0,0-.376-.375h-.751a.375.375,0,0,0-.375.375v.564a.376.376,0,0,0,.375.376h.751a.376.376,0,0,0,.376-.376Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14366",
    "data-name": "Path 14366",
    d: "M423.139,700.375v-.563h.752v.563Zm.752-.939h-.752a.375.375,0,0,0-.375.376v.563a.375.375,0,0,0,.375.376h.752a.375.375,0,0,0,.375-.376v-.563A.375.375,0,0,0,423.891,699.436Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14367",
    "data-name": "Path 14367",
    d: "M425.393,696.431h.751v.564h-.751Zm0,.939h.751a.375.375,0,0,0,.376-.375v-.564a.376.376,0,0,0-.376-.376h-.751a.376.376,0,0,0-.376.376v.564A.375.375,0,0,0,425.393,697.37Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14368",
    "data-name": "Path 14368",
    d: "M425.017,698.685a.376.376,0,0,0,.376.376.188.188,0,0,0,0-.376v-.564h.751a.188.188,0,1,0,0-.375h-.751a.375.375,0,0,0-.376.375Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14369",
    "data-name": "Path 14369",
    d: "M420.885,700.375v-.563h.751v.563Zm.751-.939h-.751a.375.375,0,0,0-.375.376v.563a.375.375,0,0,0,.375.376h.751a.376.376,0,0,0,.376-.376v-.563A.376.376,0,0,0,421.636,699.436Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14370",
    "data-name": "Path 14370",
    d: "M427.834,702.254a2.067,2.067,0,1,1,2.066-2.066A2.066,2.066,0,0,1,427.834,702.254Zm0-4.508a2.442,2.442,0,1,0,2.442,2.442A2.441,2.441,0,0,0,427.834,697.746Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14371",
    "data-name": "Path 14371",
    d: "M428.92,699.4l-1.461,1.461-.664-.664a.188.188,0,1,0-.266.266l.8.8a.187.187,0,0,0,.266,0l1.593-1.593a.188.188,0,0,0-.265-.266Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14372",
    "data-name": "Path 14372",
    d: "M423.092,687.136h0a.713.713,0,0,1-.227-.246.549.549,0,0,1-.067-.27.71.71,0,0,1,.117-.36l0-.006a10.972,10.972,0,0,1,3.132-.075.729.729,0,0,1,.157.346.622.622,0,0,1-.23.552,9.958,9.958,0,0,0-1.235-.077A10.087,10.087,0,0,0,423.092,687.136Zm7.065,1.469a10.018,10.018,0,0,0-2.445-1.15.607.607,0,0,1,.247-.848l.013-.009.006,0a10.759,10.759,0,0,1,2.665,1.262c0,.025.007.052.011.079a.539.539,0,0,1-.149.5.745.745,0,0,1-.348.167Zm-11.281.316h0a.767.767,0,0,1-.509-.215.549.549,0,0,1-.12-.432c.263-.2.538-.387.817-.56a10.81,10.81,0,0,1,1.974-.96.712.712,0,0,1,.291.247.635.635,0,0,1,.03.588h0a9.842,9.842,0,0,0-2.482,1.33Zm14.573,2.878h0a.943.943,0,0,1-.23-.03,9.754,9.754,0,0,0-1.667-2.069.529.529,0,0,1,.15-.255.649.649,0,0,1,.223-.135,1.013,1.013,0,0,1,.341-.062h.008l.065-.022a11.046,11.046,0,0,1,1.068,1.227c.213.286.415.585.6.89l0,.008A.529.529,0,0,1,433.449,691.8Zm-17.727.566h0a.619.619,0,0,1-.328-.082.543.543,0,0,1-.239-.364,10.874,10.874,0,0,1,1.606-2.293.645.645,0,0,1,.68.579v.005a10.02,10.02,0,0,0-1.491,2.131l-.006,0A.894.894,0,0,1,415.722,692.365Zm19.33,3.749h0a.733.733,0,0,1-.314-.081.89.89,0,0,1-.133-.081h0a9.933,9.933,0,0,0-.544-2.416c.012-.024.025-.051.038-.079a.586.586,0,0,1,.249-.285.623.623,0,0,1,.3-.071.974.974,0,0,1,.222.027c.039.1.077.212.113.319a10.721,10.721,0,0,1,.516,2.4A.524.524,0,0,1,435.052,696.114Zm-20.667,1.236a.45.45,0,0,1-.45-.45,10.785,10.785,0,0,1,.424-3,1.055,1.055,0,0,1,.289-.043.649.649,0,0,1,.307.069.557.557,0,0,1,.253.28,9.89,9.89,0,0,0-.372,2.693A.45.45,0,0,1,414.385,697.35Zm10.357,10.35a10.353,10.353,0,0,1-1.5-.108,9.625,9.625,0,0,1-2.8-.86,10.15,10.15,0,0,1-1.287-.745,14.055,14.055,0,0,1-4.318-5.02v2.645a.451.451,0,0,1-.9,0V700.05a.451.451,0,0,1,.45-.45h3.6a.45.45,0,0,1,0,.9h-2.381c1.561,2.874,4.412,6.3,9.135,6.3a9.88,9.88,0,0,0,9.85-8.845.55.55,0,0,1,.387-.162.874.874,0,0,1,.514.206,10.692,10.692,0,0,1-1.127,3.811,10.873,10.873,0,0,1-1.044,1.65,10.888,10.888,0,0,1-2.868,2.6,10.733,10.733,0,0,1-5.712,1.635Z",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/followUp.a7831224a68a50bf9bc8040c8b46b636.svg";
export { ForwardRef as ReactComponent };